// pre-sale.js — houdt het pre-sale-label en de pre-sale-notitie in sync met
// de gekozen variant op de productpagina.
//
// Elementen met data-pre-sale-variants dragen de lijst met variant-id's die in
// pre-sale zijn; bij een variantwissel tonen/verbergen we ze op basis daarvan.
(function () {
  'use strict';

  function sync(variantId) {
    var elements = document.querySelectorAll('[data-pre-sale-variants]');

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var ids;

      try {
        ids = JSON.parse(element.getAttribute('data-pre-sale-variants'));
      } catch (error) {
        continue;
      }

      if (!Array.isArray(ids)) continue;

      element.hidden = variantId === null || ids.indexOf(variantId) === -1;
    }
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;
    sync(variant ? Number(variant.id) : null);
  });
})();
